module.exports = __webpack_public_path__ + "media/site/images/case_studies/ekanban/trolley@2x-dc648f77245cc73fb6e9f196cf1dfc89.png";